import { Box, CircularProgress, Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { IPaginationProps, Pagination } from '@occc/ui-design-system';
import { RetailerNetworkLocationFragment } from '@occc/graphql';

import { StoreCard } from './store-card.component';

type LocationGroupStoresGridProps = {
  displayedLocations: RetailerNetworkLocationFragment[];
  loading: boolean;
  isInitialLoading: boolean;
  networkId: string;
  locationGroupId?: string;
  locationGroupName?: string;
  onRemoveFromLocationGroup?: (locationUuid: string) => Promise<void>;
  isRemoveInProgress?: boolean;
  paginationProps: IPaginationProps;
};

const INITIAL_LOADER_HEIGHT = 206;

export const LocationGroupStoresGrid = ({
  displayedLocations,
  loading,
  isInitialLoading,
  networkId,
  locationGroupId,
  locationGroupName,
  onRemoveFromLocationGroup,
  isRemoveInProgress,
  paginationProps,
}: LocationGroupStoresGridProps) => (
  <>
    <Box sx={{ position: 'relative' }}>
      {isInitialLoading ? (
        <Box
          display='flex'
          alignItems='center'
          justifyContent='center'
          sx={{ height: INITIAL_LOADER_HEIGHT }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          {loading && (
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: (theme: Theme) => alpha(theme.palette.background.paper, 0.6),
                borderRadius: 1,
                zIndex: 1,
              }}
            >
              <CircularProgress />
            </Box>
          )}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: 2,
              opacity: loading ? 0.4 : 1,
              transition: 'opacity 0.2s',
            }}
          >
            {displayedLocations.map((loc) => (
              <StoreCard
                key={loc.uuid}
                location={loc}
                networkId={networkId}
                locationGroupId={locationGroupId}
                locationGroupName={locationGroupName}
                onRemoveFromLocationGroup={onRemoveFromLocationGroup}
                isRemoveInProgress={isRemoveInProgress}
              />
            ))}
          </Box>
        </>
      )}
    </Box>
    {(displayedLocations.length > 0 || !isInitialLoading) && (
      <Box mt={3}>
        <Pagination {...paginationProps} />
      </Box>
    )}
  </>
);
